const validate = values => {
  const errors = {};


  if (!values.login) {

    errors.login = 'Campo Obrigatório';
  }
  if (!values.senha) {
    errors.senha = 'Campo Obrigatório';
  }
  if (!values.email) {
    errors.email = 'Campo Obrigatório';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.email)) {
    errors.email = 'Email Inválido';
  }
  
  if (!values.use_email) {
    errors.use_email = 'Campo Obrigatório';
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(values.use_email)) {
    errors.use_email = 'Email Inválido.';
  }
  if (!values.sex) {
    errors.sex = 'Campo Obrigatório';
  }
  if (!values.favoriteColor) {
    errors.favoriteColor = 'Campo Obrigatório';
  }

  if (!values.use_senha) {
    errors.use_senha = 'Campo Obrigatório';
  }
  return errors;
};

export default validate;



// WEBPACK FOOTER //
// ./src/service/validate_login.js